import { IFavoriteEntity } from '../../types/results';
import { getProduct } from '../../utils/trackings';
import { ca } from '@cian/analytics';

export function trackClickRemoveFromFolder(entityId: number, favoriteEntities: IFavoriteEntity[]) {
  const product = getProduct(entityId, favoriteEntities);

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'click_remove_card',
    label: '',
    products: [product],
  });
}
